<template>
  <loginless-layout :title="$t('login.title')">
    <form @submit.prevent="login">
      <v-alert
        error
        :value="!!error"
        transition="scale-transition"
        class="mb-3"
      >
        {{ error }}
      </v-alert>

      <v-select
        v-model="language"
        :items="languages"
      />

      <v-text-field
        v-model="username"
        :label="$t('login.username')"
        required
      />

      <v-text-field
        type="password"
        v-model="password"
        :label="$t('login.password')"
        required
      />

      <v-card-actions>
        <v-btn type="submit" flat :loading="isBusy">{{ $t('login.login') }}</v-btn>
      </v-card-actions>

      <div class="text-xs-center mt-2">
        <v-btn flat to="/forgotten-password">{{ $t('login.forgotten') }}</v-btn>
      </div>

    </form>
    <template slot="media"><img src="../assets/logo2.jpg" /></template>
  </loginless-layout>
</template>

<script>
import User from '@/models/User'
import Local from '@/store/local'
import LoginlessLayout from '@/components/LoginlessLayout'

import defaultRoutes from '@/router/default'

// @TODO: This his too hacky
let customStyle = null

export default {
  props: {
    logout: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      username: null,
      password: null,
      isBusy: false,
      error: null,
      language: this.$i18n.locale,
      languages: [
        {
          value: 'en',
          text: 'English'
        },
        {
          value: 'cs',
          text: 'Česky'
        }
      ]
    }
  },
  created () {
    // Forget pass when logged out
    let stored = Local.get('private')
    if (stored && stored.pass) {
      stored.pass = null
      this.$store.player.passSaved = false
      Local.set('private', stored)
    }

    if (this.logout && this.$auth.isLogged()) {
      // Remove custom style if needed, this can fail on some browsers
      try {
        if (customStyle) {
          customStyle.parentNode.removeChild(customStyle)
          customStyle = null
        }
      } catch (err) {
        console.error('Failed to remove custom style', err)
      }

      // Session related stuff
      this.$auth
        .logout()
        .then(() => {
          this.$router.push('/login')
        })

      return
    }

    if (this.$store.auth.token && this.$store.auth.username) {
      this.loadUser(this.$auth.useToken(this.$store.auth.token, this.$store.auth.username))
    }
  },
  watch: {
    language () {
      this.$i18n.locale = this.language
    }
  },
  methods: {
    login () {
      this.$store.auth = {
        user: null,
        oauth: null,
        username: this.username,
        password: this.password
      }

      this.isBusy = true

      this.loadUser(this.$auth.login(this.username, this.password))
    },
    loadUser (promise) {
      this.isBusy = true

      promise.then(user => {
        // Save use data to store
        this.$store.auth.user = user

        // Clear saved stuff, when logged as someone else
        let stored = Local.get('private')
        if (stored) {
          if (stored.username !== this.$store.auth.user.username) {
            this.$store.player.keyStored = false
            this.$store.player.passStored = false
            Local.set('private', {})
          }
        }

        // Redirect to default route or previously accessed page
        if (this.$store.login && this.$store.login.redirect) {
          this.$router.push(this.$store.login.redirect)
          this.$store.login.redirect = null
        } else {
          this.$router.push(defaultRoutes[this.$store.auth.user.role] || '/')
        }

        // Try to add custom style, this can fail on some browsers
        try {
          let company = this.$store.auth.user.company
          if (company && company.customStyle) {
            customStyle = document.createElement('link')
            customStyle.rel = 'stylesheet'
            customStyle.href = company.customStyle
            document.head.appendChild(customStyle)
          }
        } catch (e) {
          console.error('Failed to create custom style element', e)
        }

        this.username = null
        this.password = null

        this.isBusy = false
      })
      .then(() => {
        return User.getPasswordComplexity()
      })
      .then(complexity => {
        this.$store.auth.user.passwordComplexity = complexity.passwordComplexity
      })
      .catch((err) => {
        // Credentials were rejected
        console.error(err)
        this.error = this.$t('login.badCredentialsError')
        this.isBusy = false
      })
    }
  },
  components: {
    LoginlessLayout
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Login.vue?f2a7fa78